import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import FORMATTERS from 'helpers/formatters';
import {
  CustomCard,
  CustomCardBody,
  CustomCardHeader,
} from '_components/Settings/components/SettingsV2/styles';

import { Text, Value } from './styles';

function ChargeCustomer({ charge }) {
  return (
    <Row className="mt-3">
      <Col>
        <CustomCard>
          <CustomCardHeader>
            <h3>Dados do pagador</h3>
          </CustomCardHeader>
          <CustomCardBody>
            <Row>
              <Col xs={12} md={6}>
                <Text>Nome</Text>
                <Value>{charge.recipient_name}</Value>
              </Col>
              <Col xs={12} md={6}>
                <Text>CPF/CNPJ</Text>
                <Value>{FORMATTERS.CPF_CNPJ(charge.recipient_document)}</Value>
              </Col>
            </Row>
          </CustomCardBody>
        </CustomCard>
      </Col>
    </Row>
  );
}

ChargeCustomer.defaultProps = {
  charge: null,
};

ChargeCustomer.propTypes = {
  charge: PropTypes.object,
};

export default ChargeCustomer;
